import React, {useMemo} from 'react';
import {useTheme} from '@mui/material';
import type {InputLabelProps} from '@mui/material/InputLabel';
import InputLabel from '@mui/material/InputLabel';

type Props = InputLabelProps & {
  label: string;
};

export const GroupLabel: React.FC<Props> = ({label, sx, ...props}) => {
  const {palette} = useTheme();
  const style = useMemo(
    () => ({...sx, color: palette.text.primary}),
    [sx, palette],
  );
  return (
    <InputLabel {...props} sx={style}>
      {label}
    </InputLabel>
  );
};
